import { computeFileHash, uploadFile as kitUploadFile } from '@kit/lib/upload.js';
import { api } from './api.js';

// The kit's uploadFile defaults to its own `api` instance, which is bound
// to VITE_API_URL (rpgish). Assets has its own host (VITE_ASSETS_API_URL),
// so we pre-bind the assets api client here. Callers in this app can
// `import { uploadFile } from '../../lib/upload.js'` without thinking
// about which host the upload routes through.
export function uploadFile(file, options = {}) {
    return kitUploadFile(file, { ...options, api: options.api ?? api });
}

export { computeFileHash };
